// extracted by mini-css-extract-plugin
export default {"icon":"BaseInputAddress_icon__3S1OK"};